import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Table } from "react-bootstrap";
import { authFetch } from "./authFetch";

export function splitLaborAmount(amount, assignments) {
  if (!assignments.length) return [];
  const weights = assignments.map(item => Math.round(Number(item.coeficient) * 10000));
  const sum = weights.reduce((a, b) => a + b, 0);
  if (weights.some(value => !Number.isFinite(value) || value <= 0) || !Number.isFinite(amount) || amount < 0) return [];
  const cents = Math.round((amount + Number.EPSILON) * 100);
  const exact = weights.map(value => cents * value / sum);
  const shares = exact.map(Math.floor);
  const priority = exact.map((value, i) => i).sort((a, b) => (exact[b] - shares[b]) - (exact[a] - shares[a]));
  const remainder = cents - shares.reduce((a, b) => a + b, 0);
  for (let i = 0; i < remainder; i++) shares[priority[i]] += 1;
  return assignments.map((item, i) => ({ ...item, suma: shares[i] / 100 }));
}

export default function LaborEmployees({ value = [], amount, onChange }) {
  const [employees, setEmployees] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    authFetch("/angajati/").then(data => { if (active) setEmployees(data); }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);
  const shares = splitLaborAmount(amount, value);
  const add = event => {
    const employee = employees.find(item => item.id === Number(event.target.value));
    if (employee) onChange([...value, { bxangajat_id: employee.id, nume_angajat: employee.nume_prenume, coeficient: employee.coeficient }]);
  };
  return <div style={{ minWidth: 290 }}>
    {error && <Alert variant="danger">{error}</Alert>}
    <div className="small text-muted mb-1">De repartizat: {Number(amount).toFixed(2)} lei</div>
    {shares.map(item => <div key={item.bxangajat_id} className="d-flex gap-2 align-items-center mb-1 small">
      <span className="flex-grow-1">{item.nume_angajat || `Angajat #${item.bxangajat_id}`} · coef. {Number(item.coeficient)}</span>
      <strong>{item.suma.toFixed(2)} lei</strong>
      <Button variant="outline-danger" size="sm" aria-label={`Elimină ${item.nume_angajat}`} onClick={() => onChange(value.filter(row => row.bxangajat_id !== item.bxangajat_id))}>×</Button>
    </div>)}
    <Form.Select size="sm" aria-label="Adaugă angajat la manoperă" value="" onChange={add}>
      <option value="">Adaugă angajat…</option>
      {employees.filter(item => !value.some(row => row.bxangajat_id === item.id)).map(item =>
        <option key={item.id} value={item.id}>{item.nume_prenume} — coef. {Number(item.coeficient)}</option>)}
    </Form.Select>
    <div className="small text-muted">Se salvează odată cu devizul.</div>
  </div>;
}

export function LaborEmployeeSummary({ rows = [] }) {
  const grouped = new Map();
  rows.forEach(row => splitLaborAmount(Number(row.bxqty_manopera || 0) * Number(row.bxpret_manopera || 0), row.detalii_angajati || []).forEach(item => {
    const previous = grouped.get(item.bxangajat_id) || { name: item.nume_angajat, cents: 0 };
    previous.cents += Math.round(item.suma * 100);
    grouped.set(item.bxangajat_id, previous);
  }));
  if (!grouped.size) return null;
  return <div className="mt-3"><h6>Total repartizat pe angajat</h6><Table bordered size="sm">
    <thead><tr><th>Angajat</th><th>Suma cuvenită (lei)</th></tr></thead>
    <tbody>{[...grouped].map(([id, item]) => <tr key={id}><td>{item.name || `Angajat #${id}`}</td><td>{(item.cents / 100).toFixed(2)}</td></tr>)}</tbody>
  </Table></div>;
}
